import { WorkblocksPageBase } from "./WorkblocksPageBase";

/** Published site surface without internal authoring or runtime references. */
export function PublishedWorkblocksPage() {
  return <WorkblocksPageBase />;
}
